<template>
  <v-card elevation="7" color="green lighten-3" max-height="80">
    <v-form>
      <v-container fluid>
        <v-row>
          <v-col cols="12" md="6" sm="5" xs="5">
            <h3>Filtro</h3>
          </v-col>
          <v-col cols="12" md="1" sm="1" xs="1">
            <v-text-field dense v-model="loja" label="Loja" autofocus></v-text-field>
          </v-col>
          <v-col cols="12" md="2" sm="2" xs="2">
            <v-text-field dense v-model="orcamento" label="Orçamento"></v-text-field>
          </v-col>
          <v-col cols="12" md="1" sm="1" xs="1">
            <v-text-field dense v-model="serie" label="Serie"></v-text-field>
          </v-col>
          <v-col cols="12" md="2" sm="2" xs="2">
            <div class="my-2">
              <v-btn @click="adicionarFiltroOrcamentoState" color="primary" dark>
                <v-icon left>mdi-card-search</v-icon>Buscar
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data: () => ({
    loja: null,
    orcamento: null,
    serie: null
  }),
  methods: {
    ...mapActions(["adicionarFiltroOrcamento"]),
    adicionarFiltroOrcamentoState() {
      const filtroOrcamento = [this.loja, this.orcamento, this.serie];
      this.$store.dispatch("adicionarFiltroOrcamento", filtroOrcamento);
    }
  }
};
</script>

<style>
</style>